export default __webpack_public_path__ + "static/media/cryptoAssetTxn.e4c057ed.svg";